/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import Space from 'material/space/space';
import {  } from '@insticator/insticator-ui/dist/material';
// styles
import injectSheet from 'react-jss'
import styles from './commenting_styles'

const Comment = (props) => {
  const { isReply } = props
  return (
    <Space direction={'column'} style={{ marginLeft: isReply ? '24px' : 0, width: 'auto'}}>
      <Space alignItems={'center'}>
        <div className='placeholder rounded' />
        <div className='placeholder' style={{width: isReply ? '100%' : '70%'}} />
      </Space>
      <Space direction={'column'} style={{ width: 'auto', marginLeft: '24px'}}>
        <div className='placeholder' style={{width: isReply ? '80%' : '100%'}}/>
        <div className='placeholder' style={{width: isReply ? '70%' : '100%'}}/>
       {!isReply && (
        <>
           <div className='placeholder' />
           <div className='placeholder' style={{ width: '70%'}} />
        </>
       )}
      </Space>
    </Space>
  )
}
/* ========== ~~~~~~~~~~ PRODUCT MANAGER: PAGE SETUP : PREVIEW ~~~~~~~~~~ ========== */
const Commenting = injectSheet(styles)((props) => {

  const { } = props
  return (
    <div className={`commenting ${props.classes.commenting}`}>
      <Space direction={'column'} gap={4}>
        <h5>Commenting</h5>
        <hr />
      </Space>
      <Comment />
      <Comment isReply />
      <Comment isReply />
      <Comment />
      <Comment />
    </div>
   
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Commenting;
